// load styles
require('./layout-style.less');

// load dep modules
require('./header-controller');
require('./footer-controller');
require('./notifications-controller');
require('./sidebar-controller');

var module = angular.module('bbl.layout', [
	'bbl.layout.header',
	'bbl.layout.footer',
	'bbl.layout.notifications',
	'bbl.layout.sidebar',
]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/index.js
 ** module id = 78
 ** module chunks = 0
 **/